// Images for the World Cup 2026 case study, taken from the game itself.
import spain from '../../../assets/case-studies/world-cup/flags/Spain.svg';
import france from '../../../assets/case-studies/world-cup/flags/France.svg';
import england from '../../../assets/case-studies/world-cup/flags/England.svg';
import argentina from '../../../assets/case-studies/world-cup/flags/Argentina.svg';
import brazil from '../../../assets/case-studies/world-cup/flags/Brazil.svg';
import morocco from '../../../assets/case-studies/world-cup/flags/Morocco.svg';
import belgium from '../../../assets/case-studies/world-cup/flags/Belgium.svg';
import norway from '../../../assets/case-studies/world-cup/flags/Norway.svg';
import switzerland from '../../../assets/case-studies/world-cup/flags/Switzerland.svg';
import goldCrown from '../../../assets/case-studies/world-cup/gold-crown.png';
import silverCrown from '../../../assets/case-studies/world-cup/silver-crown.png';
import bronzeCrown from '../../../assets/case-studies/world-cup/bronze-crown.png';
import monkeyIcon from '../../../assets/case-studies/world-cup/monkey.svg';
import gameLogo from '../../../assets/case-studies/world-cup/ftl.png';
import stadium from '../../../assets/case-studies/world-cup/stadium.webp';
import avatar8 from '../../../assets/images/avatars/avatar8.svg';
import avatar16 from '../../../assets/images/avatars/avatar16.svg';
import avatar18 from '../../../assets/images/avatars/avatar18.svg';
import avatar21 from '../../../assets/images/avatars/avatar21.svg';
import avatar22 from '../../../assets/images/avatars/avatar22.svg';
import avatar38 from '../../../assets/images/avatars/avatar38.svg';
import avatar42 from '../../../assets/images/avatars/avatar42.svg';
import avatar44 from '../../../assets/images/avatars/avatar44.svg';

export const FLAGS = {
  Spain: spain,
  France: france,
  England: england,
  Argentina: argentina,
  Brazil: brazil,
  Morocco: morocco,
  Belgium: belgium,
  Norway: norway,
  Switzerland: switzerland,
};

// Index = podium tier (0 gold, 1 silver, 2 bronze).
export const CROWNS = [goldCrown, silverCrown, bronzeCrown];

export const AVATARS = {
  8: avatar8,
  16: avatar16,
  18: avatar18,
  21: avatar21,
  22: avatar22,
  38: avatar38,
  42: avatar42,
  44: avatar44,
};

export { monkeyIcon, gameLogo, stadium };
